import {ContractCommentService} from './service/api/contract-comment.service';
import {AssessmentGroupService} from './service/api/assessment-group.service';
import {ProductService} from './service/api/product.service';
import {PartnerGroupService} from './service/api/partner-group.service';
import {ContractTagService} from './service/api/contract-tag.service';
import {ContractPriceService} from './service/api/contract-price.service';
import {PartnerSystemLinkService} from './service/api/partner-system-link.service';
import {PartnerService} from './service/api/partner.service';
import {PartnerCategoryService} from './service/api/partner-category.service';
import {PartnerContractTypeService} from './service/api/partner-contract-type.service';
import {ContractService} from './service/api/contract.service';
import {ContractTypeService} from './service/api/contract-type.service';
import {ContractNotificationTypeService} from './service/api/contract-notification-type.service';
import {ContractBaseTypeService} from './service/api/contract-base-type.service';
import {ENTITY_SERVICE_REGISTRY, EntityServiceEntry} from '../../core/shared/dto/dto-service/entity-service-registry';
import {ProductPriceService} from './service/api/product-price.service';
import {ContractDeviantAddressService} from './service/api/contract-deviant-address.service';
import {ContractClauseTypeService} from './service/api/contract-clause-type.service';
import {ContractClauseService} from './service/api/contract-clause.service';
import {ContractIncidentService} from './service/api/contract-incident.service';
import {ContractPaymentSuspensionService} from './service/api/contract-payment-suspension.service';
import {CmPartnerComponent} from "./component/protected-components/cm-partner/cm-partner.component";
import {
    ContractObjectComponent
} from "./component/protected-components/object-base-components/contract-component/contract-object.component";
import {
    CmGeneralAgencyObjectComponent
} from "./component/object-components/cm-general-agency-object-component/cm-general-agency-object.component";

export const CM_ENTITY_PROVIDER = [
    {
        provide: ENTITY_SERVICE_REGISTRY,
        useValue: [
            ['cm.GroupAmountType', {route: '/cm/groupAmountTypes'}],

            ['cm.Division', {route: '/cm/divisions'}],
            ['cm.InsurableObject', {route: '/cm/insurableObjects'}],
            ['cm.InsurableObjectType', {route: '/cm/insurableObjectTypes'}],
            ['cm.InsurableObjectTypeField', {route: '/cm/insurableObjectTypeFields'}],
            ['cm.PriceReason', {route: '/cm/priceReasons'}],
            ['cm.ContractComment', {route: '/cm/contractComments', service: ContractCommentService}],

            ['cm.ContractOutstandingPayment', {route: '/cm/contractOutstandingPayments'}],

            ['cm.PartnerLinkContact', {route: '/cm/partnerLinkContacts'}],
            ['cm.PartnerLink', {route: '/cm/partnerLinks'}],
            ['cm.PartnerContact', {route: '/cm/partnerContacts'}],

            ['cm.AssessmentGroup', {route: '/cr/assessmentGroups', service: AssessmentGroupService}],
            ['cm.AssessmentGroupInsuranceType', {route: '/cm/assessmentGroupInsuranceTypes'}],

            ['cm.Insurance', {route: '/cm/insurances'}],
            ['cm.InsuranceAgent', {route: '/cm/insuranceAgents'}],
            ['cm.InsuranceData', {route: '/cm/insuranceDatas'}],
            ['cm.InsuranceFormerInsurance', {route: '/cm/insuranceFormerInsurances'}],

            ['cm.insuranceAcquisitionCommission', {route: '/cm/insuranceAcquisitionCommissions'}],
            ['cm.InsuranceCompany', {route: '/cm/insuranceCompanies'}],
            ['cm.InsuranceCompanyDivision', {route: '/cm/insuranceCompanyDivisions'}],
            ['cm.InsuranceCompanyGroup', {route: '/cm/insuranceCompanyGroups'}],
            ['cm.InsuranceDiscount', {route: '/cm/insuranceDiscounts'}],
            ['cm.InsurancePayment', {route: '/cm/insurancePayments'}],
            ['cm.InsurancePrice', {route: '/cm/insurancePrices'}],
            ['cm.InsurancePriceDiscount', {route: '/cm/insurancePriceDiscounts'}],
            ['cm.InsurancePriceRange', {route: '/cm/insurancePriceRanges'}],
            ['cm.InsuranceStatus', {route: '/cm/insuranceStatus'}],
            ['cm.InsuranceStatusType', {route: '/cm/insuranceStatusTypes'}],
            ['cm.InsuranceStatusTypeEntry', {route: '/cm/insuranceStatusTypeEntries'}],
            ['cm.InsuranceTariff', {route: '/cm/insuranceTariffs'}],
            ['cm.InsuranceTax', {route: '/cm/insuranceTaxes'}],
            ['cm.InsuranceType', {route: '/cm/insuranceTypes'}],
            ['cm.InsuranceTypeField', {route: '/cm/insuranceTypeFields'}],
            ['cm.InsuranceTypeInsurableObjectType', {route: '/cm/insuranceTypeInsurableObjectTypes'}],
            ['cm.InsuranceConfigDocumentGroup', {route: '/cm/insuranceConfigDocumentGroups'}],

            ['cm.Rating', {route: '/cm/ratings'}],

            ['cm.ContractPayment', {route: '/cm/contractPayments'}],
            ['cm.Product', {route: '/cm/products', objectRoute: '/cm/product/:id', service: ProductService}],
            ['cm.ContractStatusTypeEntry', {route: '/cm/contractStatusTypeEntrys'}],
            ['cm.Broker', {route: '/cm/brokers'}],
            ['cm.TagTypeScope', {route: '/cm/tagTypeScopes'}],
            ['cm.PartnerGroup', {route: '/cm/partnerGroups', service: PartnerGroupService}],
            ['cm.ContractTag', {route: 'about:blank', service: ContractTagService}],
            ['cm.ContractStatus', {route: '/cm/contractStatuss'}],
            ['cm.ContractPrice', {route: '/cm/contractPrices', service: ContractPriceService}],
            ['cm.ContractDiscount', {route: '/cm/contractDiscounts'}],
            ['cm.ContractFormer', {route: '/cm/contractFormers'}],
            ['cm.ContractData', {route: '/cm/contractDatas'}],
            ['cm.ProductData', {route: '/cm/productDatas'}],
            ['cm.ContractAgent', {route: '/cm/contractAgents'}],
            ['cm.ContractBundle', {route: '/cm/contractBundles'}],
            ['cm.ContractDocument', {route: '/cm/contractDocuments'}],
            ['cm.PartnerType', {route: '/cm/partnerTypes'}],
            ['cm.PartnerSystemLink', {route: '/cm/partnerSystemLinks', service: PartnerSystemLinkService}],
            ['cm.ProductDataField', {route: '/cm/productDataFields'}],
            ['cm.Partner', {route: '/cm/partners', service: PartnerService, objectComponent: [{component: CmPartnerComponent}]}],
            ['cm.Tax', {route: '/cm/taxs'}],
            ['cm.ContractAcquisitionCommission', {route: '/cm/contractAcquisitionCommissions'}],
            ['cm.Category', {route: '/cm/categorys'}],
            ['cm.ContractPartner', {route: '/cm/contractPartners'}],
            ['cm.TagType', {route: '/cc/tagTypes'}],
            ['cm.ContractDataField', {route: '/cm/contractDataFields'}],
            ['cm.ContractStatusType', {route: '/cm/contractStatusTypes'}],
            ['cm.ProductPartner', {route: '/cm/productPartners'}],
            ['cm.PartnerCategory', {route: '/cm/partnerCategorys', service: PartnerCategoryService}],
            ['cm.PartnerContractType', {route: '/cm/partnerContractTypes', service: PartnerContractTypeService}],
            ['cm.PriceRangeDiscount', {route: '/cm/priceRangeDiscounts'}],
            ['cm.AssessmentGroupContractType', {route: '/cm/assessmentGroupContractTypes'}],
            ['cm.ContractTypeField', {route: '/cm/contractTypeFields'}],
            ['cm.ContractTypeAmountType', {route: '/cm/contractTypeAmountTypes'}],
            ['cm.Contract', {route: '/cm/contracts', objectRoute: '/cm/contract/:id', service: ContractService, objectComponent: [{component: ContractObjectComponent}]}],
            ['cm.ContractType', {route: '/cm/contractTypes', service: ContractTypeService}],
            ['cm.RatingTypeObjectType', {route: '/cm/ratingTypeObjectTypes'}],
            ['cm.Group', {route: '/cm/groups'}],
            ['cm.RatingType', {route: '/cm/ratingTypes'}],
            ['cm.PriceRange', {route: '/cm/priceRanges'}],
            ['cm.ContractOriginType', {route: '/cm/contractOriginTypes'}],
            ['cm.ContractTerminationReasonType', {route: '/cm/contractTerminationReasonTypes'}],
            ['cm.ContractCategoryType', {route: '/cm/contractCategoryTypes'}],
            ['cm.ContractTerminationType', {route: '/cm/contractTerminationTypes'}],
            ['cm.ContractNotificationType', {route: '/cm/contractNotificationTypes', service: ContractNotificationTypeService}],
            ['cm.ContractNotificationTypeRestrictGroup', {route: '/cm/contractNotificationTypeRestrictGroups'}],
            ['cm.ContractNotificationTypeRestrictContractType', {route: '/cm/contractNotificationTypeRestrictContractTypes'}],

            ['cm.ContractOneTimePayment', {route: '/cm/contractOneTimePayments'}],
            ['cm.ContractOneTimePaymentReason', {route: '/cm/contractOneTimePaymentReasons'}],

            // Payment suspension (Beitragsaussetzung). The suspension has a service because its controller
            // has custom endpoints (/preview, /reportingState, /{id}/reportingState/reset); the reason is a
            // pure configuration entity (ObjectCrudController only), so it is route-only — a wrapper service
            // would be a no-op.
            ['cm.ContractPaymentSuspension', {route: '/cm/contractPaymentSuspensions', service: ContractPaymentSuspensionService}],
            ['cm.ContractPaymentSuspensionReason', {route: '/cm/contractPaymentSuspensionReasons'}],

            ['cm.ContractConfigDocumentGroup', {route: '/cm/contractConfigDocumentGroups'}],
            ['cm.PartnerAddress', {route: '/cm/partnerAddresss'}],
            ['cm.ContractBaseTypeTicketType', {route: '/cm/contractBaseTypeTicketTypes'}],
            ['cm.ContractTypeNotificationType', {route: '/cm/contractTypeNotificationTypes'}],
            ['cm.ContractPriceEntryTypeField', {route: '/cm/contractPriceEntryTypeFields'}],
            ['cm.ContractBaseStatus', {route: '/cm/contractBaseStatuss'}],
            ['cm.ContractBaseCategory', {route: '/cm/contractBaseCategorys'}],
            ['cm.ContractClosureChannelType', {route: '/cm/contractClosureChannelTypes'}],
            ['cm.ContractBaseTypeReason', {route: '/cm/contractBaseTypeReasons'}],
            ['cm.ContractBaseType', {route: '/cm/contractBaseTypes', service: ContractBaseTypeService}],
            ['cm.RoleAuthContract', {route: '/cm/roleAuthContracts'}],
            ['cm.ContractPriceEntryType', {route: '/cm/contractPriceEntryTypes'}],
            ['cm.ContractLabel', {route: '/cm/contractLabels'}],

            ['cm.RoleAuthContractIndex', {route: '/cm/roleAuthContractIndexs'}],

            ['cm.ContractTypeComponent', {route: '/cm/contractTypeComponents'}],
            ['cm.ContractTypeComponentDependency', {route: '/cm/contractTypeComponentDependencys'}],
            ['cm.ProductComponent', {route: '/cm/productComponents'}],
            ['cm.ProductContractPersonType', {route: '/cm/productContractPersonTypes'}],
            // Tariff variant (Tarifvariante) and base coverage value lists of a product. They replace the
            // single-valued Product.biproTariffKey / Product.gdvTariffKey pair; the cw module narrows them
            // per case-type product via cw.CwCaseTypeProductTariff / cw.CwCaseTypeProductBaseCoverage.
            // Route-only: both are pure generic CRUD (ObjectCrudController, no custom endpoint), so the
            // framework's generic MvsCrudService serves them — a wrapper service would be a no-op.
            ['cm.ProductTariff', {route: '/cm/productTariffs'}],
            ['cm.ProductBaseCoverage', {route: '/cm/productBaseCoverages'}],
            // ci-coverage-type FD-7: cm.ContractCoverage moved to ci.ContractCoverage — see ci.entity-provider.ts
            ['cm.ProductPrice', {route: '/cm/productPrices', service: ProductPriceService}],

            ['cm.ContractDateType', {route: '/cm/contractDateTypes'}],
            ['cm.ContractDate', {route: '/cm/contractDates'}],

            ['cm.ContractDeviantAddress', {route: '/cm/contractDeviantAddresses', service: ContractDeviantAddressService}],

            ['cm.ContractClauseType', {route: '/cm/contractClauseTypes', service: ContractClauseTypeService}],
            ['cm.ContractClause', {route: '/cm/contractClauses', service: ContractClauseService}],
            ['cm.ContractIncident', {route: '/cm/contractIncidents', service: ContractIncidentService}],

            // General Agency (Generalagentur)
            ['cm.GeneralAgency', {route: '/cm/generalAgencies', objectComponent: [{component: CmGeneralAgencyObjectComponent}]}],
            ['cm.GeneralAgencyNumber', {route: '/cm/generalAgencyNumbers'}],
            ['cm.GeneralAgencyAgent', {route: '/cm/generalAgencyAgents'}],
            ['cm.GeneralAgencyNumberAgent', {route: '/cm/generalAgencyNumberAgents'}],
            ['cm.GeneralAgencyNumberGroup', {route: '/cm/generalAgencyNumberGroups'}],
            ['cm.GeneralAgencyNumberContractType', {route: '/cm/generalAgencyNumberContractTypes'}],

        ] as EntityServiceEntry[],
        multi: true
    }
];
